import { store, type Middleware } from 'foca';

import { globalSettingModel } from './global-setting.model';

const middleware: Middleware[] = [];

store.init({
  compose: 'redux-devtools',
  middleware,
  persist: [
    {
      key:
        'parrot-vault' + (import.meta.env.MODE === 'mainnet' ? 'production' : import.meta.env.MODE),
      version: 1,
      engine: localStorage,
      models: [globalSettingModel],
    },
  ],
});

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('Store updated');
  });
}
